const ImageOrientationDirective = function () {

  var directive = {
    restrict: 'A',
    scope: {
      imgorientation: "@"
    },
    link: function ($scope, element) {

      var $element = angular.element(element);
      $element.find('img').each(function (index, imgElement) {
        var $imgElement = angular.element(imgElement);
        $imgElement.on(
          'load',
          { '$imgElement': $imgElement, '$element': $element },
          function (event) {
            var $containerElement = event.data.$element;
            var $imgElement = event.data.$imgElement;
            $imgElement.css('margin-top', '')
              .css('margin-bottom', '')
              .css('margin-left', '')
              .css('margin-right', '');

            if ($imgElement.data('changedOrientation')) {
              $imgElement.width('100%').height('auto');
            }

            directive.orientate($containerElement, $imgElement);
          }
        );
      });
    },

    orientate: function ($containerElement, $imgElement) {

      var containerHeight = $containerElement.height();
      var imgHeight = $imgElement.height();
      var marginHeight = (containerHeight - imgHeight) / 2;

      var containerWidth = $containerElement.width();
      var imgWidth = $imgElement.width();
      var marginWidth = (containerWidth - imgWidth) / 2;

      if (imgHeight === 0 || imgWidth === 0) {
        return;
      }

      if (marginHeight * 2 !== 0 && marginWidth * 2 !== 0) {
        $imgElement.width(containerWidth);
        $imgElement.height('auto');
        $imgElement.data('changedOrientation', 'height');

        return this.orientate($containerElement, $imgElement);
      }

      if (containerHeight < imgHeight) {
        $imgElement.width('auto');
        $imgElement.height(containerHeight);
        $imgElement.data('changedOrientation', 'width');

        return this.orientate($containerElement, $imgElement);
      }

      if (marginHeight > 0) {
        $imgElement.css('margin-top', marginHeight);
        $imgElement.css('margin-bottom', marginHeight);
      }
      if (marginWidth > 0) {
        $imgElement.css('margin-left', marginWidth);
        $imgElement.css('margin-right', marginWidth);
      }
    }
  };
  return directive;
};
/**
 * orientate all images in the element on which this directive is set
 * margin-top and margin-bottom are set
 */


export default ImageOrientationDirective;
